/**
 * Flux DC App Service
 *
 * CRUD operations for DC projects plus optimization and simulation submission.
 */

import { fetchDC } from './api';

/**
 * Get all DC projects
 */
export async function getProjects() {
  return fetchDC('/projects');
}

/**
 * Get a single DC project by ID
 */
export async function getProject(projectId) {
  return fetchDC(`/projects/${projectId}`);
}

/**
 * Create a new DC project
 */
export async function createProject(projectData) {
  return fetchDC('/projects', {
    method: 'POST',
    body: JSON.stringify(projectData),
  });
}

/**
 * Update an existing DC project
 */
export async function updateProject(projectId, projectData) {
  return fetchDC(`/projects/${projectId}`, {
    method: 'PUT',
    body: JSON.stringify(projectData),
  });
}

/**
 * Delete a DC project
 */
export async function deleteProject(projectId) {
  return fetchDC(`/projects/${projectId}`, {
    method: 'DELETE',
  });
}

/**
 * Submit optimization for a DC project
 */
export async function submitOptimization(dcScenario) {
  return fetchDC('/optimize', {
    method: 'POST',
    body: JSON.stringify(dcScenario),
  });
}

/**
 * Poll optimization/simulation results
 */
export async function getResults(jobId) {
  return fetchDC(`/results/${jobId}`);
}

/**
 * Submit UL 3141 simulation
 */
export async function submitUL3141Simulation(simulationConfig) {
  return fetchDC('/simulate/ul3141', {
    method: 'POST',
    body: JSON.stringify(simulationConfig),
  });
}

/**
 * Get IT load presets
 */
export async function getITLoadPresets() {
  return fetchDC('/presets/it-load');
}

/**
 * Get cooling plant presets
 */
export async function getCoolingPresets() {
  return fetchDC('/presets/cooling');
}
